import { createFileRoute, redirect } from '@tanstack/react-router';

import { getCurrentSession } from '../app/auth-state';
import { UndeliveredSmsPage } from '../modules/sms/ui/pages/UndeliveredSmsPage';

export const Route = createFileRoute('/_authenticated/dashboard/sms/undelivered')({
  // Operational delivery view scoped to the org: org_admin and supervisor only.
  // Backend RBAC is the source of truth; this guard blocks direct-URL access from
  // operator and super_admin (cross-tenant, org-scoped data is not relevant).
  beforeLoad: () => {
    const session = getCurrentSession();
    if (!session) {
      throw redirect({ to: '/login' });
    }
    const role = session.user.role;
    if (role !== 'org_admin' && role !== 'supervisor') {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: UndeliveredSmsPage,
  staticData: {
    breadcrumb: ['Operate', 'Undelivered SMS'],
  },
});
